import React, { useState } from "react";
import { currencyUSD } from "../../helpers/forms/formater";
import { useNavigate } from "react-router-dom";
import { AlertTriangle, Eye, Save, Pencil } from "lucide-react";
import { Tooltip } from "react-tooltip";
import CustomSelect from "../../components/form/CustomSelect";
import { salesResource } from "../../helpers/configRoutes/backend_helper";

const Columns = (sellers, setFilters, filters, rows, setRows, items, setItems) => {
    const navigate = useNavigate()

    const asignSeller = (row, id) => {
        const exists = rows.find(r => r.id === row.id);

        if (exists) {
            // Si ya existe, actualiza el existente
            const updatedRows = rows.map(r =>
                r.id === row.id ? { ...r, seller_id: id } : r
            );
            setRows(updatedRows);
        } else {
            // Si no existe, agrégalo al arreglo
            setRows([...rows, { ...row, seller_id: id }]);
        }
    };

    const saveSale = async (row) => {
        const response = await salesResource('put', row, row.id)
        if (response.status) {
            setFilters({ ...filters })
        }
    }

    const editItem = (item) => {
        console.log(item)
        const newArray = items.map((i) => {
            if (item.id === i.id) {
                return {
                    ...i,
                    seller_id: null,
                    seller: {},
                    error: 'No existe categoria'
                };
            }
            return i;
        });
        setItems(newArray)
        const productsSnCategory = newArray
            .filter(pr => !pr.seller_id)
            .map(pr => pr);

        setRows(productsSnCategory);
    }

    let columns = [
        {
            id: 'folio',
            name: 'No. FACT',
            selector: row => `${row.invoice?.folio}`,
        },
        {
            id: 'payment_terms',
            name: 'CONDICIONES DE PAGO',
            selector: row => `${row.payment_terms}`,
        },
        {
            id: 'seller',
            name: 'Vendedor',
            selector: row => (
                <div className="flex items-center gap-2 relative">
                    {row.seller?.information?.name ?
                        <>
                            <span>{row.seller?.information?.name}</span>
                            <button onClick={() => editItem(row)} className="text-blue-500 hover:text-blue-700">
                                <Pencil size={16} />
                            </button>
                        </>
                        :
                        <div className="min-w-[160px]">
                            <CustomSelect
                                isClearable={true}
                                className="text-sm"
                                holder="Vendedor"
                                options={sellers}
                                value={rows.find((r) => r.id == row.id)?.seller_id}
                                handleChange={(e) => asignSeller(row, e.target.value)}
                            />
                        </div>
                    }

                    {(row.error && rows.find((r) => r.id == row.id)?.seller_id == null) && (
                        <div className="text-fr-danger" data-tooltip-id={`error-${row.id}`}>
                            <AlertTriangle size={16} />
                            <Tooltip id={`error-${row.id}`} place="top">
                                Error 
                            </Tooltip>
                        </div>
                    )}

                    {(row.error && rows.find((r) => r.id === row.id)?.seller_id != null) && (
                        <div className="text-fr-success" data-tooltip-id={`error-${row.id}`}>
                            <AlertTriangle size={16} />
                            <Tooltip id={`error-${row.id}`} place="top">
                                Error
                            </Tooltip>
                        </div>
                    )}
                </div>
            ),
        },
        {
            id: 'total',
            name: 'SUBTOTAL',
            selector: row => (
                <span className="text-fr-success font-semibold bg-fr-success/10 px-3 py-1 rounded-full text-sm">
                    {currencyUSD(row.subtotal ?? 0)}
                </span>
            )
        },
        {
            id: 'client',
            name: 'Cliente',
            selector: row => `${row.client_name}`,
        },


        {
            id: 'date',
            name: 'Fecha',
            selector: row => `${row.date}`,
        },

        {
            id: 'acciones',
            name: 'Acciones',
            selector: (row) => (
                <div className="flex items-center gap-3">
                    <button
                        className="text-fr-primary hover:text-fr-primary-hover transition"
                        onClick={() => navigate(`/venta/${row.id}`)}
                        title="Editar"
                    >
                        <Eye size={18} />
                    </button>
                    {(row.error.product && rows.find((r) => r.id == row.id)?.seller_id == null) && (
                        <div className="text-red-600" data-tooltip-id={`error-${row.id}`}>
                            <AlertTriangle size={16} />
                            <Tooltip id={`error-${row.id}`} place="top">
                                {row.error.product}. Error hay productos que no tienen asignada una area
                            </Tooltip>
                        </div>
                    )}
                </div>
            ),
        }
    ]
    return columns;
}

export default Columns;